import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const CallAgentBox = styled.div`
  display: none;
  margin-top: 15px;

  @media (${mobileXXLargeMax}) {
    display: block;
  }
`;

export const ShowNumberBox = styled.div`
  display: block;
  margin-top: 15px;

  @media (${mobileXXLargeMax}) {
    display: none;
  }
`;
